import ProductSwatches from './ProductSwatches';

export default ProductSwatches;
